import { Divider, Drawer } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../colors-v2';
import { Box } from '../../Common/BoxV2';
import { Typography } from '../../DesignSystemV2/Typography';
import { SelectedFilters } from '../SelectedFilters';
import { FilterMobileStore } from '../store/filter-mobile.store';
import { useFilterMobileStore } from '../useStore';
import { FilterGroup } from './FilterGroup';
import { Footer } from './Footer';

const Main = styled.div`
  display: grid;
  grid-auto-flow: row;
  grid-auto-rows: max-content;
  grid-template-columns: 1fr;
  height: 100%;
  gap: 16px;
`;

export const FilterMobile = observer(() => {
  const filterMobileStore = useFilterMobileStore();

  if (!filterMobileStore) return null;

  const { open, setClose, visibleGroupWithoutSort } = filterMobileStore;

  return (
    <Drawer
      title={<Typography.Text variant="semi-bold/20">Bộ lọc</Typography.Text>}
      width={375}
      placement="right"
      closable={false}
      onClose={setClose}
      open={open}
      footer={<Footer />}
      headerStyle={{
        padding: 16,
      }}
      bodyStyle={{
        padding: 16,
      }}
    >
      <Main>
        <SelectedFilters model={FilterMobileStore} />

        <Box>
          {visibleGroupWithoutSort
            .filter((group) => group.queryKey !== 'sort')
            .map((group, idx, arr) => (
              <React.Fragment key={group.uuid}>
                <FilterGroup groupId={group.uuid} key={group.uuid} model={FilterMobileStore} />
                {idx < arr.length - 1 && <HorizontalDivider />}
              </React.Fragment>
            ))}
        </Box>
      </Main>
    </Drawer>
  );
});

const HorizontalDivider = styled(Divider)`
  background: ${colorsV2.black10};
  height: 6px;
  border: none;
  margin: 6px -16px;
  width: calc(100% + 32px);
`;
